export default __webpack_public_path__ + "static/default_image-fab1a4087e247be15b6d01e101550e9e.png";